export const addQuad = (
  vertList: number[],
  fromCoord: [number, number],
  toCoord: [number, number],
  z: number
) => {
  vertList.push(fromCoord[0], fromCoord[1], z)
  vertList.push(toCoord[0], fromCoord[1], z)
  vertList.push(fromCoord[0], toCoord[1], z)
  vertList.push(fromCoord[0], toCoord[1], z)
  vertList.push(toCoord[0], fromCoord[1], z)
  vertList.push(toCoord[0], toCoord[1], z)
  return vertList
}
